import React from "react";

const Footer = () => {
  return (
    <div className="container-fluid footer">
      <div className="container h-100 d-flex align-items-center justify-content-center">
        <p className="text-white">&copy; Joshua Barlolong, 2022 </p>
      </div>
    </div>
  );
};

export default Footer;
